import { toSentenceCase } from 'utils/helpers/helpers'

export const USER_TOKEN = 'USER_TOKEN'
export const EMAIL = 'EMAIL'
export const REMEMBERME = 'REMEMBERME'
export const SETTINGS = 'ADMIN_SETTINGS'

// COGNITO ERROR CODES
export const NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException'

// TOKEN ERROR MESSAGES
export const ACCESS_TOKEN_EXPIRED = 'Access Token has expired'
export const INVALID_ACCESS_TOKEN = 'Invalid Access Token'
export const MISSING_AUTH_HEADER = 'Authorization header is missing or invalid'

// WELCOME MESSAGE
export const WELCOME_TITLE = `Welcome to ${process.env.REACT_APP_CLIENT_NAME === 'delco'
    ? 'Del-Co'
    : toSentenceCase(process.env.REACT_APP_CLIENT_NAME)
    } Admin Portal`
export const WELCOME_DESCRIPTION = ''
